export default __webpack_public_path__ + "static/media/flipTips.8b7b4f89.svg";